import type { FocusArea, Modality } from "~/lib/matching/taxonomy";

/**
 * Lowercase: these render inside a sentence, e.g. "Radi sa: anksioznost,
 * depresija, trauma". Must cover every key in FOCUS_AREAS (35).
 */
export const FOCUS_AREA_LABELS: Record<FocusArea, string> = {
  anxiety: "anksioznost",
  panic_attacks: "panični napadi",
  depression: "depresija",
  burnout: "sagorevanje",
  stress: "stres",
  trauma: "trauma",
  grief_loss: "gubitak i žalovanje",
  ocd: "opsesivno-kompulzivni poremećaj",
  addictions: "zavisnosti",
  self_esteem: "samopouzdanje",
  boundaries: "granice",
  relationships: "problemi u odnosima",
  communication: "komunikacija",
  emotional_regulation: "regulacija emocija",
  phobias: "fobije",
  life_crises: "životne krize",
  parenting: "roditeljstvo",
  identity: "identitet",
  anger: "bes",
  shame_guilt: "stid i krivica",
  lgbtq: "LGBTQ tematika",
  adolescents: "adolescenti",
  couples_issues: "partnerski odnosi",
  eating_disorders: "poremećaji ishrane",
  sleep_problems: "problemi sa spavanjem",
  narcissistic_abuse: "narcističko zlostavljanje",
  social_anxiety: "socijalna anksioznost",
  procrastination: "prokrastinacija",
  decision_making: "donošenje odluka",
  self_development: "lični razvoj",
  childhood_development: "razvojni problemi kod dece",
  family_issues: "porodični odnosi",
  work_issues: "problemi na poslu",
  motivation: "nedostatak motivacije",
  loneliness: "usamljenost",
};

/**
 * Sentence case: these render as standalone chips/labels. Must cover every
 * value in MODALITIES (13), the same enum the match-profile extractor uses.
 */
export const MODALITY_LABELS: Record<Modality, string> = {
  kbt: "KBT pristup",
  rebt: "REBT / KBT pristup",
  gestalt: "Geštalt pristup",
  act: "ACT pristup",
  cft: "CFT pristup",
  dbt: "DBT pristup",
  psychodynamic: "Psihodinamski pristup",
  integrative: "Integrativni pristup",
  systemic: "Sistemski porodični pristup",
  emdr: "EMDR pristup",
  mindfulness: "Mindfulness pristup",
  other: "Drugi terapijski pristup",
  unknown: "Terapijski pristup nije naveden",
};
